import { activeLocale } from "~vue/utils/formatDate";
const fallbackTimezoneLabel = (timezone: string) => timezone.replaceAll("/", ", ").replaceAll("_", " ");

export const formatTimezoneLabel = (timezone: string) => {
    try {
        const label = new Intl.DateTimeFormat(activeLocale(), { timeZone: timezone, timeZoneName: "longGeneric" })
            .formatToParts()
            .find((part) => part.type === "timeZoneName")?.value;
        return label ?? fallbackTimezoneLabel(timezone);
    } catch {
        return fallbackTimezoneLabel(timezone);
    }
};

export const formatWeekdayInTimezone = (date: Date, timezone?: string) => {
    const options: Intl.DateTimeFormatOptions = { weekday: "long" };
    if (timezone) {
        options.timeZone = timezone;
    }

    try {
        return new Intl.DateTimeFormat(activeLocale(), options).format(date);
    } catch {
        return new Intl.DateTimeFormat(activeLocale(), { weekday: "long" }).format(date);
    }
};
